module.exports = __webpack_public_path__ + "img/icon-fb.ec75babc.svg";